import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { UtilityService } from '../../../services/utility.service';
import { trigger, transition, style, animate, query, stagger, group } from '@angular/animations';


@Component({
  selector: 'app-utility-sidebar',
  standalone: true,
  imports: [MatListModule, MatIconModule, MatCardModule, RouterLink, RouterLinkActive],
  templateUrl: './utility-sidebar.component.html',
  styleUrl: './utility-sidebar.component.css',
  animations: [
      trigger('loadListAnimation', [
        transition('* => *', [
          query(':enter', [
            style({ 
              opacity: 0, 
              transform: 'translateY(5px)' 
            }),
            stagger(50, [
              animate('500ms cubic-bezier(0.4, 0.0, 0.2, 1)', 
                style({ 
                  opacity: 1, 
                  transform: 'translateY(0)' 
                })
              )
            ])
          ], { optional: true })
        ])
      ])
    ],
})
export class UtilitySidebarComponent {
  utilityService = inject(UtilityService);
}
